export default {
  jobs: {
    title: '职位招聘',
    searchPlaceholder: '搜索职位',
    viewDetails: '查看详情',
    loading: '加载中...',
    empty: '暂无职位信息',
    jobDetails: '职位详情',
    location: '地点：',
    publishTime: '发布时间：',
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    education: '学历',
    resume: '简历',
    availableDate: '可入职时间',
    selectAvailableDate: '请选择可入职时间',
    selfIntroduction: '自我介绍',
    selfIntroductionPlaceholder: '请简要介绍自己',
    uploadTip: '拖拽文件到此处，或点击上传',
    resumeFormatTip: '支持PDF、Word格式，文件大小不超过5MB',
    applyForJob: '申请职位',
    applyTable: '申请表',
    form: {
      namePlaceholder: '请输入您的姓名',
      emailPlaceholder: '请输入您的邮箱',
      phonePlaceholder: '请输入您的电话',
      educationPlaceholder: '请输入您的学历',
      submitting: '提交中...'
    },
    success: {
      submitSuccess: '申请提交成功',
      uploadSuccess: '上传成功'
    },
    errors: {
      fetchFailed: '获取职位信息失败',
      validationFailed: '表单验证失败，请检查输入',
      nameRequired: '请输入姓名',
      emailRequired: '请输入邮箱',
      educationRequired: '请输入学历',
      phoneRequired: '请输入电话',
      resumeRequired: '请上传简历',
      submitFailed: '提交失败',
      uploadFailed: '上传失败'
    }
  },
  cooperationManagement: {
    title: '合作意向管理',
    searchPlaceholder: '搜索姓名/公司/合作内容',
    searchButton: '搜索',
    resetButton: '重置',
    createdTime: '创建时间',
    action: '操作',
    viewDetail: '查看详情',
    delete: '删除',
    batchDelete: '批量删除',
    detailTitle: '合作意向详情',
    close: '关闭',
    deleteConfirm: '确定要删除这条数据吗？',
    confirmTitle: '确认操作',
    confirmButton: '确定',
    cancelButton: '取消',
    deleteSuccess: '删除成功',
    batchDeleteSuccess: '批量删除成功',
    batchDeleteConfirm: '确定要删除选中的',
    items: '条数据',
    selectFirst: '请先选择要操作的数据',
    fetchError: '获取数据失败：',
    fetchDetailError: '获取详情失败：',
    deleteError: '删除失败：'
  },
  cooperation: {
    title: '合作意向',
    formTitle: '填写合作意向',
    formDescription: '我们将在1个工作日与您取得联系',
    name: '姓名',
    namePlaceholder: '请输入您的姓名',
    nameRequired: '请输入姓名',
    nameLength: '姓名长度不能超过50个字符',
    company: '公司',
    companyPlaceholder: '请输入您的公司名称',
    companyRequired: '请输入公司名称',
    companyLength: '公司名称长度不能超过100个字符',
    position: '职位',
    positionPlaceholder: '请输入您的职位',
    positionRequired: '请输入职位',
    positionLength: '职位长度不能超过50个字符',
    phoneNumber: '手机号',
    phoneNumberPlaceholder: '请输入您的手机号',
    phoneNumberRequired: '请输入手机号',
    phoneNumberFormat: '请输入正确的手机号码',
    email: '邮箱',
    emailPlaceholder: '请输入您的邮箱',
    emailRequired: '请输入邮箱',
    emailFormat: '请输入正确的邮箱地址',
    cooperationIntention: '合作意向内容',
    cooperationIntentionPlaceholder: '请详细描述您的合作意向（至少10个字符）',
    cooperationIntentionRequired: '请输入合作意向内容',
    cooperationIntentionLength: '合作意向内容长度在10-1000个字符之间',
    submitButton: '提交',
    resetButton: '重置',
    submitSuccess: '提交成功，感谢您的合作意向！',
    submitError: '提交失败：',
    // 联系信息相关
    locations: {
      wenzhou: '温州',
      china: '中国'
    },
    addressInfo: {
      suzhouAddress: '浙江省温州市瓯海经济开发区东方南路50号温州市国家大学科技园5号楼3楼339室'
    },
    map: {
      address: '地址',
      phone: '电话',
      email: '邮箱',
      minimize: '最小化',
      maximize: '全屏化'
    },
    contact: {
      address: '地址',
      phone: '电话',
      email: '邮箱',
      minimize: '最小化'
    }
  },
  login: {
    title: '管理员登录',
    usernameLabel: '用户名:',
    usernamePlaceholder: '请输入用户名',
    passwordLabel: '密码:',
    passwordPlaceholder: '请输入密码',
    loginButton: '登录',
    errors: {
      emptyFields: '请输入用户名和密码',
      loginFailed: '登录失败',
      tryAgain: '登录失败，请稍后重试'
    }
  },
  product: {
    title: '产品中心',
    page: {
      noTemplates: '该产品暂无模板',
      createTemplate: '创建模板',
      createDialogTitle: '创建产品模板',
      templateSelection: '模板选择',
      keywords: '关键词',
      keywordsPlaceholder: '请输入关键词',
      cancel: '取消',
      confirm: '确定',
      confirmCreate: '确认创建',
      deleteConfirm: '确定删除吗？',
      deleteConfirmTitle: '删除确认',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      templateCreatedSuccess: '模板创建成功',
      templateCreateFailed: '模板创建失败：',
      deleteFailedAlert: '删除失败，请重试',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      updateFailedAlert: '更新失败，请重试',
        errorTitle: '错误',
        keywordsPlaceholder: '请输入关键词',
        keywordsLengthLimit: '关键词长度在 1 到 200 个字符'
     },
    errors: {
      fetchFailed: '获取产品列表失败',
      productIdNotFound: '产品ID不存在',
      fetchProductInfoFailed: '获取产品信息失败',
      fetchProductInfoError: '获取产品信息出错',
      fetchTemplatesFailed: '获取产品模板失败',
      fetchTemplatesError: '获取产品模板出错',
      deleteTemplateFailed: '删除模板失败',
      createTemplateFailed: '创建模板失败，请稍后重试'
    }
  },
  backgroundEditor: {
    title: '背景设置',
    preview: '预览',
    link: '链接',
    upload: '本地上传',
    imagePlaceholder: '请选择或输入图片',
    videoPlaceholder: '请选择或输入视频',
    imageLinkPlaceholder: '请输入图片链接',
    videoLinkPlaceholder: '请输入视频链接',
    invalidImageUrl: '请输入有效的图片URL',
    invalidVideoUrl: '请输入有效的视频URL',
    failedToLoadImage: '无法加载图片，请检查链接是否正确',
    failedToLoadVideo: '无法加载视频，请检查链接是否正确',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    saving: '保存中...',
    save: '保存',
    cancel: '取消',
    linkError: '链接有误',
    waitForUpload: '请等待文件上传完成后再保存',
    loadFailed: '获取内容失败，请稍后重试',
    dataFormatError: '数据格式错误，请检查输入内容'
  },
  navbar: {
    logo: 'KUNSTEP',
    home: '首页',
    products: '产品中心',
    technology: '技术特色',
    about: '公司介绍',
    news: '新闻动态',
    join: '加入我们',
    contact: '联系我们',
    admin: '管理',
    login: '登录',
    logout: '登出'
  },
  admin: {
    menu: {
      settings: '系统设置',
      products: '产品管理',
      categories: '分类管理',
      tags: '标签管理',
      news: '新闻管理',
      jobs: '职位管理',
      jobApplications: '职位申请管理',
      cooperation: '合作意向管理',
      banners: 'Banner管理'
    },
    cooperationCase: {
      title: '合作案例管理',
      addCase: '添加合作案例',
      editCase: '编辑合作案例',
      partnerName: '合作方名称',
      partnerNamePlaceholder: '请输入合作方名称',
      partnerNameRequired: '请输入合作方名称',
      iconUrl: '图标URL',
      iconUrlPlaceholder: '请输入图标URL',
      iconUrlRequired: '请输入图标URL',
      localUpload: '本地上传',
      orderNum: '排序序号',
      createdAt: '创建时间',
      createSuccess: '合作案例创建成功',
      updateSuccess: '合作案例更新成功',
      deleteSuccess: '合作案例删除成功',
      deleteConfirm: '确定要删除该合作案例吗？'
    },
    contactInfo: {
      title: '联系信息管理',
      addContactInfo: '添加联系信息',
      editContactInfo: '编辑联系信息',
      contactName: '联系地名称',
      contactNameEn: '联系地名称英文',
      contactNamePlaceholder: '请输入联系地名称',
      contactNameEnPlaceholder: '请输入联系地名称英文',
      contactNameRequired: '请输入联系地名称',
      country: '国家',
      countryEn: '国家英文',
      countryPlaceholder: '请输入国家',
      countryEnPlaceholder: '请输入国家英文',
      countryRequired: '请输入国家',
      address: '地址',
      addressEn: '地址英文',
      addressPlaceholder: '请输入地址',
      addressEnPlaceholder: '请输入地址英文',
      addressRequired: '请输入地址',
      phone: '联系电话',
      phonePlaceholder: '请输入联系电话',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱',
      latitude: '纬度',
      latitudePlaceholder: '请输入纬度',
      longitude: '经度',
      longitudePlaceholder: '请输入经度',
      backupField1: '备用字段1',
      backupField1Placeholder: '请输入备用字段1',
      backupField2: '备用字段2',
      backupField2Placeholder: '请输入备用字段2',
      backupField3: '备用字段3',
      backupField3Placeholder: '请输入备用字段3',
      sortOrder: '排序序号',
      createdAt: '创建时间',
      createSuccess: '联系信息创建成功',
      updateSuccess: '联系信息更新成功',
      deleteSuccess: '联系信息删除成功',
      deleteConfirm: '确定要删除该联系信息吗？',
      batchDeleteSuccess: '批量删除联系信息成功',
      batchDeleteConfirm: '确定要删除选中的联系信息吗？',
      selectItemsFirst: '请先选择要操作的联系信息',
      fetchFailed: '获取联系信息失败',
      submitFailed: '提交失败'
    },
    page: {
      settings: '系统设置',
      products: '产品管理',
      categories: '分类管理',
      tags: '标签管理',
      news: '新闻管理',
      jobs: '职位管理',
      jobApplications: '职位申请管理',
      cooperation: '合作意向管理',
      banners: 'Banner管理',
      cooperationCaseManagement: '合作案例管理',
      contactInfoManagement: '联系信息管理'
    },
    logout: '退出登录',
    confirmLogout: '确认退出',
    search: '搜索',
    reset: '重置',
    cancel: '取消',
    submit: '提交',
    ok: '确定',
    confirm: '确认',
    all: '全部',
    actions: '操作',
    upload: {
      failed: '上传失败',
      productSuccess: '上传成功',
      newsSuccess: '上传成功'
    },
    queryFailed: '查询失败',
    error: {
      fetchFailed: '获取数据失败',
      saveFailed: '保存失败',
      deleteFailed: '删除失败',
      updateFailed: '更新失败',
      queryFailed: '查询失败'
    },

    products: {
      title: '产品管理',
      addProduct: '添加产品',
      editProduct: '编辑产品',
      name: '产品名称',
      namePlaceholder: '请输入产品名称',
      nameRequired: '请输入产品名称',
      nameEn: '产品英文名称',
      nameEnPlaceholder: '请输入产品英文名称',
      category: '产品分类',
      selectCategory: '请选择分类',
      categoryRequired: '请选择产品分类',
      tags: '产品标签',
      selectTags: '请选择标签',
      price: '价格',
      priceRequired: '请输入价格',
      stock: '库存',
      stockRequired: '请输入库存',
      status: '状态',
      description: '描述',
      descriptionPlaceholder: '请输入产品描述',
      mainImage: '主图',
      mainImageTip: '请上传产品主图',
      mainImageRequired: '请上传产品主图',
      createSuccess: '产品创建成功',
      updateSuccess: '产品更新成功',
      deleteSuccess: '产品删除成功',
      deleteConfirm: '确定要删除该产品吗？'
    },
    categories: {
      title: '分类管理',
      addCategory: '添加分类',
      editCategory: '编辑分类',
      name: '分类名称',
      namePlaceholder: '请输入分类名称',
      nameRequired: '请输入分类名称',
      description: '分类描述',
      descriptionPlaceholder: '请输入分类描述',
      createdAt: '创建时间',
      createSuccess: '分类创建成功',
      updateSuccess: '分类更新成功',
      deleteSuccess: '分类删除成功',
      deleteConfirm: '确定要删除该分类吗？'
    },
    tags: {
      title: '标签管理',
      addTag: '添加标签',
      editTag: '编辑标签',
      name: '标签名称',
      namePlaceholder: '请输入标签名称',
      nameRequired: '请输入标签名称',
      color: '标签颜色',
      colorRequired: '请选择标签颜色',
      createdAt: '创建时间',
      createSuccess: '标签创建成功',
      updateSuccess: '标签更新成功',
      deleteSuccess: '标签删除成功',
      deleteConfirm: '确定要删除该标签吗？'
    },
    news: {
      title: '新闻管理',
      addNews: '添加新闻',
      editNews: '编辑新闻',
      publishTimePlaceholder: '请选择发布时间',
      title: '新闻标题',
      titlePlaceholder: '请输入新闻标题',
      titleRequired: '请输入新闻标题',
      summary: '新闻概要',
      summaryPlaceholder: '请输入新闻概要',
      summaryRequired: '请输入新闻概要',
      coverImage: '新闻封面',
      coverImageTip: '请上传新闻封面图',
      coverImageRequired: '请上传新闻封面图',
      publishTime: '发布时间',
      publishTimeRequired: '请选择发布时间',
      linkUrl: '跳转链接',
      linkUrlPlaceholder: '请输入新闻跳转链接',
      uploadSuccess: '上传成功',
      uploadFailed: '上传失败',
      createSuccess: '新闻创建成功',
      updateSuccess: '新闻更新成功',
      deleteSuccess: '新闻删除成功',
      deleteConfirm: '确定要删除该新闻吗？'
    },
    banner: {
    title: 'Banner管理',
    addBanner: '添加Banner',
    editBanner: '编辑Banner',
    titlePlaceholder: '请输入Banner标题',
    titleRequired: '请输入Banner标题',
    bannerUrl: 'Banner图片',
    bannerImageTip: '请上传Banner图片',
    bannerUrlRequired: '请上传Banner图片',
    bannerUrlPlaceholder: '请输入Banner图片URL',
    linkUrl: '跳转链接',
    linkUrlPlaceholder: '请输入Banner跳转链接（可选）',
    sortOrder: '排序',
    isEnabled: '是否启用',
    statusUpdateSuccess: '状态更新成功',
    createdAt: '创建时间',
    createSuccess: 'Banner创建成功',
    updateSuccess: 'Banner更新成功',
    deleteSuccess: 'Banner删除成功',
    deleteConfirm: '确定要删除该Banner吗？',
    localUpload: '本地上传',
    bannerImageFileList: 'Banner图文件列表',
    errors: {
      fetchFailed: '获取Banner列表失败'
    }
    },
    jobs: {
      title: '职位管理',
      addJob: '添加职位',
      editJob: '编辑职位',
      jobName: '职位名称',
      titlePlaceholder: '请输入职位名称',
      titleRequired: '请输入职位名称',
      location: '工作地点',
      locationPlaceholder: '请输入工作地点',
      locationRequired: '请输入工作地点',
      description: '职位内容',
      descriptionPlaceholder: '请输入职位内容',
      descriptionRequired: '请输入职位内容',
      createSuccess: '职位创建成功',
      updateSuccess: '职位更新成功',
      deleteSuccess: '职位删除成功',
      deleteConfirm: '确定要删除该职位吗？',
      searchPlaceholder: '搜索职位',
      viewDetails: '查看详情',
      loading: '加载中...',
      empty: '暂无职位数据',
      jobDetails: '职位详情',
      locationLabel: '地点：',
      publishTimeLabel: '发布时间：',
      uploadTip: '点击或拖拽文件到此处上传',
      resumeFormatTip: '支持 .pdf, .doc, .docx 格式',
      selectAvailableDate: '选择可入职日期',
      selfIntroductionPlaceholder: '请介绍一下自己',
      applyForJob: '申请该职位',
      namePlaceholder: '请输入您的姓名',
      emailPlaceholder: '请输入您的邮箱',
      phonePlaceholder: '请输入您的电话',
      educationPlaceholder: '请输入您的学历',
      autoSubmitting: '正在自动提交...',
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      education: '学历',
      resume: '简历',
      availableDate: '可入职日期',
      selfIntroduction: '自我介绍',
      errors: {
        nameRequired: '请输入姓名',
        emailRequired: '请输入邮箱',
        emailInvalid: '请输入有效的邮箱地址',
        educationRequired: '请输入学历',
        phoneRequired: '请输入电话',
        phoneInvalid: '请输入有效的手机号码',
        resumeRequired: '请上传简历',
        validationFailed: '验证未通过，请检查并完善信息',
        fetchListFailed: '获取职位列表失败',
        fetchDetailFailed: '获取职位详情失败',
        submitFailed: '职位申请提交失败，请稍后重试'
       },
      success: {
        submitting: '正在提交申请...',
        submitSuccess: '职位申请提交成功！',
        uploadSuccess: '上传成功！',
        uploadFailed: '上传失败！'
      }
    },
    jobApplications: {
      title: '职位申请管理',
      applicationId: '申请ID',
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      education: '学历',
      jobTitle: '职位名称',
      selectJob: '选择职位',
      status: '状态',
      applyTime: '申请时间',
      resume: '简历',
      coverLetter: '求职信',
      availableDate: '可入职日期',
      selfIntroduction: '自我介绍',
      viewResume: '查看简历',
      viewCoverLetter: '查看求职信',
      download: '下载',
      actionRequired: '操作提示',
      newTabBlocked: '浏览器阻止了新标签页的打开，是否下载该文件？',
      fileTypeNotSupported: '该文件类型不支持在浏览器中直接打开，是否下载？',
      viewDetails: '详情',
      updateStatus: '更新状态',
      delete: '删除',
      deleteConfirm: '确定要删除该职位申请吗？',
      statusUpdateSuccess: '状态更新成功',
      deleteSuccess: '删除成功',
      searchPlaceholder: '搜索姓名、邮箱或电话',
      search: '搜索',
      reset: '重置',
      submit: '提交',
      confirm: '确认',
      cancel: '取消',
      statusOptions: {
        pending: '待处理',
        reviewed: '已查看',
        interviewed: '已面试',
        approved: '已通过',
        rejected: '已拒绝'
      },
      details: '职位申请详情',
      close: '关闭',
      selectStatus: '请选择状态',
      statusRequired: '请选择状态',
      exportSelectedData: '导出选中数据',
      exportAllData: '导出全部数据',
      exportData: '导出数据',
      readStatus: '已读状态',
      read: '已读',
      unread: '未读',
      error: {
        fetchFailed: '获取数据失败',
        updateFailed: '更新失败',
        deleteFailed: '删除失败'
      }
}
  },
  language: {
    zh: '中文',
    en: 'English'
  },
  news: {
    title: '新闻动态',
    moreNews: '更多动态',
    loading: '加载中...',
    empty: '暂无新闻信息',
    publishTime: '发布时间',
    company: '企业动态'
  },
  jobs: {
    title: '加入我们',
    searchPlaceholder: '搜索职位',
    jobList: '职位列表',
    viewDetails: '查看详情 →',
    loading: '加载中...',
    loadedAll: '已显示全部岗位',
    loadMore: '加载更多',
    empty: '暂无职位信息',
    jobDetails: '职位详情',
    location: '工作地点：',
    publishTime: '发布时间：',
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    education: '学历',
    resume: '简历',
    uploadTip: '拖拽文件到此处或 点击上传',
    resumeFormatTip: '请上传PDF、Word格式的简历文件',
    availableDate: '可入职日期',
    selectAvailableDate: '选择可入职日期',
    selfIntroduction: '自我介绍',
    selfIntroductionPlaceholder: '请简要介绍您自己和为什么适合这个职位',
    autoSubmitting: '系统正在自动处理您的申请，请稍候...',
    applyForJob: '申请职位',
    form: {
      namePlaceholder: '请输入您的姓名',
      emailPlaceholder: '请输入您的邮箱',
      phonePlaceholder: '请输入您的电话',
      educationPlaceholder: '请输入您的学历',
      submitting: '正在提交申请...'
    },
    errors: {
      fetchFailed: '获取职位列表失败',
      validationFailed: '验证未通过，请检查并完善信息',
      nameRequired: '请输入姓名',
      emailRequired: '请输入邮箱',
      emailInvalid: '请输入有效的邮箱地址',
      educationRequired: '请输入学历',
      phoneRequired: '请输入电话',
      phoneInvalid: '请输入有效的手机号码',
      resumeRequired: '请上传简历',
      submitFailed: '职位申请提交失败，请稍后重试',
      uploadFailed: '上传失败！'
    },
    success: {
      submitSuccess: '职位申请提交成功！',
      uploadSuccess: '上传成功！'
    }
  },
  demo: {
    baseComTitle: 'BaseCom组件使用示例',
    baseComExample1: '示例1：使用插槽',
    baseComExample2: '示例2：使用content属性',
    baseComExample3: '示例3：不可编辑状态',
    baseComSlotContent: '这是通过插槽传入的内容',
    baseComPropContent: '这是通过content属性传入的内容',
    baseComNonEditableContent: '这是不可编辑的内容',
    textComTitle: 'TextCom组件使用示例',
    textComExample1: '示例1：默认文本样式',
    textComExample2: '示例2：自定义字体大小和颜色',
    textComExample3: '示例3：使用插槽自定义内容',
    textComDefaultContent: '这是默认样式的文本',
    textComCustomContent: '这是自定义样式的文本',
    textComSlotContent: '这是通过插槽传入的自定义内容',
    containerComTitle: 'ContainerCom组件使用示例',
    containerComExample1: '示例1：使用图片背景',
    containerComExample2: '示例2：使用静态背景色',
    containerComImageContent: '图片背景容器示例',
    containerComStaticContent: '静态背景容器示例（视频因CORS限制暂不可用）'
  },
  // 技术特性相关内容
  technology: {
    title: '前沿科技 就在身边',
    feature1: {
      title: '精准步态监测',
      desc: '多传感器信号融合，实时统计步长、步速、关节角度，精确辨别行走姿态，肌肉异常监测触发目标肌肉动作。'
    },
    feature2: {
      title: '稳定动态力控',
      desc: '精确的控制系统，前馈反馈等控制力，让系统在复杂动态环境中依然能实现精准的力觉控制，保证运动强度和效果。'
    },
    feature3: {
      title: '智能助力优化',
      desc: '在持续学习中，设备从步态反馈，迭代优化助力方式，高效向患者真实的步态，个性化的体验，精准的效果推向极致。'
    },
    feature4: {
      title: '行走数据可视',
      desc: '传感器的高检测和记录，让数据可视化患者行走姿态，从而可以追踪，分析和重复对比不同时期的步行状态。'
    }
  },
  messages: {
    editClick: '编辑按钮被点击！',
    editingText: '正在编辑文本...',
    editingContainer: '正在编辑容器...',
    languageSwitched: '语言已切换为{language}',
    saveSuccess: '保存成功',
    saveFailed: '保存失败'
  },
  contactFloat: {
    contactPhone: '联系咨询电话',
    wechatQRCode: '添加客服微信',
    qrCodePlaceholder: '微信二维码',
    onlineContact: '在线联系',
    onlineContact2: '在线联系',
    phoneContact: '电话沟通',
    wechatConsult: '微信咨询',
    scanToAdd: '扫一扫添加',
    kunbuRobot: '鲲步机器人'
  },
  footer: {
    copyright: 'Copyright © 2025 版权所有',
    licenseNumbers: '工业和信息化部备案网站号 浙ICP备2025210763号-2 ',
    addressTitle: '温州, 中国',
    addressDetail: '浙江省温州市瓯海经济开发区东方南路50号温州市国家大学科技园5号楼3楼339室',
    phone: '+86-18968921608',
    city: 'WenZhou'
  },
  about: {
    company: '关于鲲步',
    team: '鲲步团队',
    cases: '合作案例'
  },
}
